import axios from 'axios'

export const state = {
}

export const getters = {
}

export const mutations = {
}

export const actions = {
  resolveReturns({ commit }, { params = {} }) {
    return axios.get(`/return-orders/search`, { params })
  },
  resolveReturn({ commit }, id) {
    return axios.get(`/return-orders/${id}`)
  },
  createReturn({ commit }, data) {
    return axios.post('/return-orders', data)
  },
  updateReturn({ commit }, data) {
    return axios.put(`/return-orders/${data.id}`, data)
  },
  updateItemsAdditional({ commit }, {id, data}) {
    return axios.put(`/return-orders/${id}/items-additional`, data)
  },
  changeReturnStatus({ commit }, params) {
    const payload = {}
    const returnId = params.id
    payload.status = params.status
    payload.is_check = params.is_check
    return axios.put(`/return-orders/${returnId}/change-status`, payload)
  },
  deleteReturn({ commit }, id) {
    // Deprecated
    return axios.delete(`/return-orders/${id}`)
  },
  resolveReturnableStocks({ commit }, params ) {
    const payload = {}
    const warehouseId = params.warehouseId
    payload.supplier_ids = params.supplierId
    if (params.limit){
      payload.limit = params.limit
    }
    if(params.ids){
      payload.ids = params.ids
    }
    if(params.fields){
      payload.fields = params.fields
    }
    if(params.statuses){
      payload.statuses = params.statuses
    } else {
      payload.statuses = 'in_stock'
    }
    if(params.page){
      payload.page = params.page
    } else {
      payload.page = 1
    }
    if(params.search){
      payload.search = params.search
    }
    params = payload
    return axios.get(`/warehouses/${warehouseId}/return-stocks`, {params})
  },
}
